import { Typography } from "antd";
import { showError } from "common/ToastNotifications";
import { DomainDataPreviewList, FullHeightContainerLayout } from "components";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Title, Text } = Typography;

class EventDomainData extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        if (this.props.itemOperation && this.props.eventType === "BATCH_PROCESSING") {
            let headerText = "";
            let headerDetails = `(Business Area Data: ${this.props.domainName})`;
            switch (this.props.itemOperation) {
                case "INSERT":
                    headerText = "Inserted domain records";
                    break;
                case "DELETE":
                    headerText = "Deleted domain records";
                    break;
                default:
                    break;
            }
            this.setState({
                headerText,
                headerDetails,
            });
            this.props.getEventDomainDataList(this.props.eventId, this.props.itemOperation, null);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetEventDomainDataListResultUpdate(prevProps);
    }

    onGetEventDomainDataListResultUpdate = (prevProps) => {
        if (this.props.getEventDomainDataListResult && this.props.getEventDomainDataListResult !== prevProps.getEventDomainDataListResult) {
            if (!this.props.getEventDomainDataListResult.success) {
                if (this.props.getEventDomainDataListResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to get domain at this moment.");
                }
            }
        }
    };

    getEventDomainData = (pagination) => {
        if (this.props.domainDataResult.pageKey && pagination.current * pagination.pageSize >= this.props.domainDataResult.Items.length) {
            this.props.getEventDomainDataList(this.props.eventId, this.props.itemOperation, this.props.domainDataResult.pageKey);
        }
    };

    render() {
        return (
            <FullHeightContainerLayout
                showHeader={true}
                showFooter={false}
                header={
                    <Title level={5}>
                        <Text>Event Batch - </Text>
                        <Text>{this.state.headerText}</Text>
                        <Text> - </Text>
                        <Text type="secondary">{this.state.headerDetails}</Text>
                    </Title>
                }
                content={
                    <DomainDataPreviewList
                        recordCount={this.props.recordCount || 0}
                        domainDataList={this.props.domainDataResult.Items && this.props.domainDataResult.Items.map((item) => item.data)}
                        loading={this.props.domainDataResult.inProgress ? { description: "Loading data..." } : false}
                        onPageSelect={this.getEventDomainData}
                    ></DomainDataPreviewList>
                }
            ></FullHeightContainerLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getEventDomainDataListResult: state.eventDomainData.getEventDomainDataListResult,
        domainDataResult: state.eventDomainData.domainDataResult,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEventDomainDataList: (eventId, itemOperation, pageKey) => dispatch(actions.getEventDomainDataListRequest(eventId, itemOperation, pageKey)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EventDomainData));
